module.exports = __webpack_public_path__ + "img/loading.9e2f927e.gif";